// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__307Pi","calendarButtons":"ClockData_calendarButtons__Lj_ze"};